// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "2fd4cacbbe88a3a01d98486e961c7cfd" + ".js";
};